import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTRSNode } from 'API/TRSNodes/createTRSNode';

const useCreateTRSNode = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const createNode = async (nodeData) => {
        try {
            const response = await createTRSNode(nodeData);
            return response.data;
        } catch (error) {
            console.error('Error creating TRS node:', error);
            throw error;
        }
    };

    return useMutation({
        mutationFn: createNode,
        onSuccess: (data) => {
            // Invalidate and refetch the nodes list
            queryClient.invalidateQueries({ queryKey: ['TRSNodes'] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useCreateTRSNode;
